import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  //   AdapterDayjs,
  Alert,
} from "@mui/material";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useCreateStudyQuery } from "../../../api/useCreateStudy";
import { useUpdateStudyQuery } from "../../../api/useUpdateStudy";
import { useQueryClient } from "@tanstack/react-query";
import { SUBJECT } from "../../../common/constants/subject";
const StudyDialog = ({
  isModalOpen,
  closeModal,
  editMode = false,
  initialData,
}) => {
  const [formData, setFormData] = useState({
    title: "",
    category: "",
    season: "",
    startDate: null,
    endDate: null,
  });

  const queryClient = useQueryClient();
  const [errorMessage, setErrorMessage] = useState(null);
  const { mutate: createStudy, error } = useCreateStudyQuery();
  const { mutate: updateStudy, error: updateError } = useUpdateStudyQuery();

  const handleSubmit = (event) => {
    event.preventDefault();
    const { title, season, category, endDate, startDate } = formData;

    createStudy(
      {
        title,
        season,
        category,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries("studies"); // 성공 시 스터디 목록 쿼리를 다시 불러옴
          closeModal();
        },
        onError: (error) => {
          setErrorMessage(error.response.data.message);
        },
      }
    );
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleUpdate = (event) => {
    event.preventDefault();
    const { title, season, category, endDate, startDate } = formData;
    updateStudy(
      {
        title,
        season,
        category,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        id: initialData._id,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries("studies"); // 성공 시 스터디 목록 쿼리를 다시 불러옴
          closeModal();
        },
        onError: (error) => {
          setErrorMessage(error.response.data.message);
        },
      }
    );
  };
  useEffect(() => {
    if (editMode && initialData) {
      setFormData({
        title: initialData.title,
        category: initialData.category,
        season: initialData.season,
        startDate: dayjs(initialData.startDate),
        endDate: dayjs(initialData.endDate),
      });
    } else {
      setFormData({
        title: "",
        category: "",
        season: "",
        startDate: null,
        endDate: null,
      });
    }
  }, [editMode, initialData]);
  return (
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>새 스터디 개설하기</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="제목"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>카테고리</InputLabel>
              <Select
                name="category"
                value={formData.category}
                label="카테고리"
                onChange={handleChange}
              >
                {/* 카테고리 옵션 구성 */}
                {SUBJECT.map((subject) => (
                  <MenuItem value={subject.value}>{subject.title}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="시즌"
              name="season"
              value={formData.season}
              onChange={handleChange}
            />
          </Grid>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="시작일"
                value={formData.startDate}
                onChange={(newValue) => {
                  setFormData({ ...formData, startDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="종료일"
                value={formData.endDate}
                onChange={(newValue) => {
                  setFormData({ ...formData, endDate: newValue });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </Grid>
          </LocalizationProvider>
          {errorMessage && <Alert>{errorMessage}</Alert>}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>Cancel</Button>
        {editMode ? (
          <Button onClick={handleUpdate}>수정하기</Button>
        ) : (
          <Button onClick={handleSubmit}>만들기</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default StudyDialog;
